export const resolveColorVariant = (variant, theme) => {
  const variantMap = {
    info: theme.tokens.ComponentBadgeIconInfoColor,
    error: theme.tokens.ComponentBadgeIconErrorColor,
    success: theme.tokens.ComponentBadgeIconSuccessColor,
    caution: theme.tokens.ComponentBadgeIconCautionColor,
    transparent: theme.tokens.ComponentBadgeIconDefaultColor,
    light: theme.tokens.ComponentBadgeIconDefaultColor,
    white: theme.tokens.ComponentBadgeIconDefaultColor,
    dark: '',
    'transparent-dark': ''
  };
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return variantMap[variant];
};